// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CallerVm from "../../../view-model/CallerVm.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

function getTableSchema(workspaceDispatch) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Customer's Name"
            },
            accessor: (function (data) {
                return {
                        TAG: /* Text */0,
                        _0: data.name
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Company/Shop Name"
              },
              accessor: (function (data) {
                  return {
                          TAG: /* Text */0,
                          _0: Belt_Option.getWithDefault(data.vendor_name, "N/A")
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Primary Number"
                },
                accessor: (function (data) {
                    return {
                            TAG: /* Text */0,
                            _0: data.primary_number
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Secondary Number"
                  },
                  accessor: (function (data) {
                      return {
                              TAG: /* Text */0,
                              _0: Belt_Option.getWithDefault(data.secondary_number, "N/A")
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: ""
                    },
                    accessor: (function (data) {
                        return {
                                TAG: /* Custom */5,
                                _0: (function (param) {
                                    return React.createElement(PrimaryButton$Catalyst.make, {
                                                buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                                      TAG: /* Text */0,
                                                      _0: "View Profile"
                                                    }, undefined, (function (_event) {
                                                        return Curry._2(workspaceDispatch.addTab, {
                                                                    TAG: /* CustomerProfileNew */2,
                                                                    _0: data.primary_number,
                                                                    _1: data.id
                                                                  }, false);
                                                      }), undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                                              });
                                  })
                              };
                      })
                  },
                  tl: /* [] */0
                }
              }
            }
          }
        };
}

function make(customer) {
  var data = {
    hd: customer,
    tl: /* [] */0
  };
  return List.map(CallerVm.CustomerVm.getVm, data);
}

var TableRowGenerator = {
  make: make
};

function CustomerDetailTable(Props) {
  var customer = Props.customer;
  var workspaceDispatch = Props.workspaceDispatch;
  return React.createElement("div", {
              className: "c-search-result c-customer-table"
            }, React.createElement("h2", undefined, "Customer"), React.createElement(TableComponent$Catalyst.make, {
                  columns: getTableSchema(workspaceDispatch),
                  rowData: make(customer)
                }));
}

var make$1 = CustomerDetailTable;

export {
  getTableSchema ,
  TableRowGenerator ,
  make$1 as make,
  
}
/* react Not a pure module */
